<button uiButton type="button" class="icon-trigger"
  cdkOverlayOrigin #origin="cdkOverlayOrigin" #trigger
  [disabled]="disabled" [attr.aria-label]="label + ': ' + selectedLabel"
  [attr.title]="label + ': ' + selectedLabel" aria-haspopup="menu"
  [attr.aria-expanded]="open()" [attr.aria-controls]="open() ? menuId : null"
  (click)="toggle()" (keydown)="triggerKeydown($event)">
  <i [class]="safeIcon" aria-hidden="true"></i>
  <i class="pi pi-chevron-down" aria-hidden="true"></i>
</button>
<ng-template cdkConnectedOverlay
  [cdkConnectedOverlayOrigin]="origin" [cdkConnectedOverlayOpen]="open()"
  [cdkConnectedOverlayHasBackdrop]="true"
  cdkConnectedOverlayBackdropClass="cdk-overlay-transparent-backdrop"
  [cdkConnectedOverlayPositions]="positions" [cdkConnectedOverlayPush]="true"
  [cdkConnectedOverlayViewportMargin]="8"
  (attach)="focusCurrent()" (backdropClick)="close()" (detach)="detached()"
  (overlayKeydown)="menuKeydown($event)">
  <div #panel class="icon-picker" role="menu" [id]="menuId" [attr.aria-label]="label">
    <button uiButton *ngFor="let icon of icons; let index = index"
      type="button" role="menuitemradio" class="icon-choice"
      [attr.aria-label]="icon.label" [attr.title]="icon.label"
      [attr.aria-checked]="value === icon.code" [attr.tabindex]="index === activeIndex ? 0 : -1"
      [severity]="value === icon.code ? 'primary' : 'secondary'"
      [outlined]="value !== icon.code" [disabled]="disabled"
      (focus)="activeIndex = index" (click)="choose(icon.code)">
      <i [class]="icon.code" aria-hidden="true"></i>
      <span *ngIf="value === icon.code" class="icon-choice__selected" aria-hidden="true">✓</span>
    </button>
  </div>
</ng-template>
